<template>
  <el-drawer
    title="Beneficiary"
    :visible.sync="showDrawer"
    :with-header="withHeader"
    :before-close="handleClose"
    :size="drawerWidth"
  >
    <transition name="fade-in">
      <component
        :is="currentView"
        :beneficiary-details="beneficiaryDetails"
        @toggle-view="toggleViewHandler"
        @refresh="refreshHandler"
        @close="handleClose"
      />
    </transition>
  </el-drawer>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    beneficiaryDetails: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    beneficiaryDetails: () =>
      import('@/components/v2/bulkPayout/drawers/BeneficiaryDetails.vue'),
    EditBulkPayout: () =>
      import('@/components/v2/bulkPayout/drawers/EditBulkPayout.vue'),
    transition: () =>
      import('@/components/v2/animation/transition/Transition.vue')
  },
  data () {
    return {
      breakpoints,
      currentView: 'beneficiary-details',
      withHeader: true
    }
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '100%'
    },
    size () {
      return breakpoints.lgAndUp ? 50 : breakpoints.mdAndUp ? 50 : 40
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    },
    toggleViewHandler (view) {
      this.currentView = view
      this.withHeader = !this.withHeader
    },
    refreshHandler () {
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped>
>>> .el-drawer__header > :first-child {
  font-size: 1.1rem;
  color: var(--foreground-default);
  font-weight: 600;
}

>>> .el-drawer {
  background: var(--background-canvas) !important;
}
</style>
